module.exports = __webpack_public_path__ + "static/media/Frielingsdorf.251586f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/vereine/Frielingsdorf.png
// module id = 596
// module chunks = 0